import moment from 'moment/moment';
import {
  NumberFormatter,
  CurrencyFormatter,
} from '@procore/globalization-toolkit';

const buildCompanySizeText = (business, I18n) => {
  const numberFormatter = new NumberFormatter({
    locale: 'en-US',
  });
  let companySizeText;
  if (!business?.companySize?.start && business?.companySize?.end) {
    companySizeText = I18n.t('components.company_size.low_range_value', {
      // eslint-disable-next-line no-unsafe-optional-chaining
      end: numberFormatter.formatNumber(business?.companySize?.end + 1),
    });
  } else if (business?.companySize?.start && !business?.companySize?.end) {
    companySizeText = I18n.t('components.company_size.high_range_value', {
      // eslint-disable-next-line no-unsafe-optional-chaining
      start: numberFormatter.formatNumber(business?.companySize?.start - 1),
    });
  } else {
    companySizeText = I18n.t('components.company_size.medium_range_value', {
      start: numberFormatter.formatNumber(business?.companySize?.start),
      end: numberFormatter.formatNumber(business?.companySize?.end),
    });
  }
  return companySizeText;
};

const buildAvgContractSizeText = (business, I18n) => {
  const currencyFormatter = new CurrencyFormatter({
    locale: 'en-US',
    currencyIsoCode: 'USD',
    minimumFractionDigits: 0,
  });
  let avgContractSizeText;
  if (!business?.avgContractSize?.start && business?.avgContractSize?.end) {
    avgContractSizeText = I18n.t(
      'components.avg_contract_size.low_range_value',
      {
        end: currencyFormatter.formatCurrency(
          // eslint-disable-next-line no-unsafe-optional-chaining
          business?.avgContractSize?.end + 1
        ),
        currency: 'USD',
      }
    );
  } else if (
    business?.avgContractSize?.start &&
    !business?.avgContractSize?.end
  ) {
    avgContractSizeText = I18n.t(
      'components.avg_contract_size.high_range_value',
      {
        start: currencyFormatter.formatCurrency(
          // eslint-disable-next-line no-unsafe-optional-chaining
          business?.avgContractSize?.start - 1
        ),
        currency: 'USD',
      }
    );
  } else {
    avgContractSizeText = I18n.t(
      'components.avg_contract_size.medium_range_value',
      {
        start: currencyFormatter.formatCurrency(
          business?.avgContractSize?.start
        ),
        end: currencyFormatter.formatCurrency(business?.avgContractSize?.end),
        currency: 'USD',
      }
    );
  }
  return avgContractSizeText;
};

const buildJoinedProcoreInText = (business, I18n) => {
  if (!business.monolithCreatedAt) {
    return '';
  }
  const momentObject = moment.utc(business.monolithCreatedAt);
  const monthKey = momentObject.format('MMMM').toLowerCase();
  const month = I18n.t(`components.months.${monthKey}`);
  const year = momentObject.format('YYYY');
  return `${I18n.t('components.joined_procore_in')} ${month} ${year}`;
};

const buildActivityDateInText = (business, I18n) => {
  if (!business.monolithCreatedAt) {
    return null;
  }
  const momentObject = moment.utc(business.monolithCreatedAt);
  const monthKey = momentObject.format('MMMM').toLowerCase();
  const month = I18n.t(`components.months.${monthKey}`);
  const year = momentObject.format('YYYY');
  return `${I18n.t('components.since')} ${month} ${year}`;
};

export {
  buildCompanySizeText,
  buildAvgContractSizeText,
  buildJoinedProcoreInText,
  buildActivityDateInText,
};
